import React from 'react';
import './posts.scss';

const SSLC1 = () => {
  return (
    <div className="evaluation-container">
      <h1>Attended Staff-Student Liaison Committee (SSLC) as a Representative</h1>
      <h3>Category: Student Activity</h3>
      <p className="date">Written on Saturday, 6 Feb 2025, in the main library.</p>
      <p>
        We had the Staff-Student Liaison Committee (SSLC) meeting on February 6. The Junior Honours agenda included discussions on
        introducing optional hand-ins and providing more question materials to help students prepare for the May exam.
        However, I believe a major topic of discussion was the balance between coursework and exams.
      </p>
      <p>
        Currently, most courses follow an 80% exam / 20% coursework structure, with the final exam being the only
        assessment—no midterms or class tests. This format can be overwhelming, as a single heavily weighted exam
        does not account for students' performance throughout the semester.
      </p>
      <div className="image-container">
        <img
            src="https://firebasestorage.googleapis.com/v0/b/portfolio-bfe5b.appspot.com/o/sslcagendastat.jpeg?alt=media&token=90e3b859-6a9e-4f66-b2db-5dbbcd08f985"
            alt="sslc-agenda-stat1"
            className="cafe-image"
        />
        <img
            src="https://firebasestorage.googleapis.com/v0/b/portfolio-bfe5b.appspot.com/o/sslcagendastat2.png?alt=media&token=cf2e2855-f0e5-4781-a73e-fda5bfd92f9f"
            alt="sslc-agenda-stat2"
            className="cafe-image"
        />
      </div>
      <p>
        To address this concern, we conducted a survey across the School of Physics, gathering 315 responses.
        The results were clear: 221 students preferred significant coursework, and this preference remained
        consistent across different degree programmes. Our goal in raising this issue was not to eliminate exams,
        but to advocate for a more balanced system—one that distributes the workload more evenly through midterms
        or multiple class tests.
      </p>
      <p>
        Unfortunately, during the meeting, an individual (whom I will keep anonymous) misrepresented the discussion—despite
        not having participated in the survey or prior discussions. This person claimed that students skip lectures and workshops
        simply because they are lazy, citing their own peers as examples. I was deeply disappointed by this statement, especially
        since it was made by a student representative.
      </p>
      <p>
        This perspective completely disregards the diverse circumstances of students. For example, one of my peers lives with two
        younger siblings, taking full responsibility for their care. Attending every lecture and workshop is simply not feasible for
        him, as he needs to work to provide for his family. If he were to attend all sessions, he wouldn’t be able to afford food,
        rent, or even hot water for a shower. To label students like him as lazy is not only uninformed but also deeply unfair.
      </p>
      <p>
        What was even more frustrating was that this was not an agreed talking point for the SSLC meeting. The person in question
        might not have realised this—likely due to not checking the group chat. Due to time constraints, we were unable to address
        all the important points we had intended to discuss, which was disappointing.
      </p>
      <p>
        This experience has taught me the importance of ensuring all representatives fully understand the agenda and their role in
        discussions. Moving forward, I will make sure this kind of situation never happens again.
      </p>

    </div>
  );
};

export default SSLC1;